import { render } from "./NewMineItemRedesign.vue?vue&type=template&id=272fa502&scoped=true"
import script from "./NewMineItemRedesign.vue?vue&type=script&lang=js"
export * from "./NewMineItemRedesign.vue?vue&type=script&lang=js"

import "./NewMineItemRedesign.vue?vue&type=style&index=0&id=272fa502&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272fa502"]])

export default __exports__